import { all, putResolve, takeLatest } from 'redux-saga/effects';
import actions from '../../actions';
import * as GetPublishMethods from '../../utils/api/publish/GetPublishData';

function* GetPublishData(payload) {
  const promise = GetPublishMethods.GetPublishData(payload.payload);
  const { res } = yield promise;
  yield putResolve({ type: actions.PublishAction.PUBLISH_DATA_RECEIVED, data: res.Response });
}

export  { GetPublishData }